<template>
  <section class="search-drawer-group">
    <slot />
  </section>
</template>

<script>

/**
 * Vue: search drawer group (search-drawer-group)
 * -----------------------------------------------------------------------------
 * Search drawer section group component.
 *
 */

export default {
  name: 'SearchDrawerGroup',
}
</script>
